/**
 * Logo strip — "Trusted by aircraft owners since 1984" (Single service, TZ section 2):
 * logos scroll horizontally in a continuous loop. Logic: utils/logo-marquee.js.
 */
import {initLogoMarquee} from "../../utils/logo-marquee.js";

const SPEED = 40; // px per second — lower = slower
const SPEED_MOB = 25; // < 1025px: the same px/s looks faster on a narrow screen

const speed = () => (window.matchMedia('(min-width: 1025px)').matches ? SPEED : SPEED_MOB);

export const logoStrip = () => {
    return new Promise((resolve) => {
        document.querySelectorAll('.logo-strip__logos').forEach((strip) => initLogoMarquee(strip, {
            track: '.logo-strip__track',
            group: '.logo-strip__group',
            speed,
        }));
        resolve();
    });
};
